import {
    getTriagesByCompany,
    Triage,
    URGENCY_LABELS,
} from '@/lib/api/triages/triage-api'
import { useEffect, useState } from 'react'

interface ConsultationFieldsProps {
    title: string
    onTitleChange: (value: string) => void
    triageId: string
    onTriageIdChange: (value: string) => void
    clientId: string
    companyId: number
    diagnosis: string
    onDiagnosisChange: (value: string) => void
    treatmentPlan: string
    onTreatmentPlanChange: (value: string) => void
}

export default function ConsultationFields({
    title,
    onTitleChange,
    triageId,
    onTriageIdChange,
    clientId,
    companyId,
    diagnosis,
    onDiagnosisChange,
    treatmentPlan,
    onTreatmentPlanChange,
}: ConsultationFieldsProps) {
    const [triages, setTriages] = useState<Triage[]>([])
    const [clientTriages, setClientTriages] = useState<Triage[]>([])

    useEffect(() => {
        if (companyId) {
            getTriagesByCompany(companyId).then(res => {
                if (res.success) setTriages(res.result || [])
            })
        }
    }, [companyId])

    useEffect(() => {
        if (clientId && triages.length > 0) {
            setClientTriages(
                triages.filter(t => t.clientId === parseInt(clientId, 10))
            )
        } else {
            setClientTriages([])
        }
    }, [clientId, triages])

    return (
        <>
            {/* "Consulta de retorno" mora no bloco "Valores e responsáveis":
                marcar retorno pode suprimir a cobrança, então a escolha precisa
                estar à vista ANTES da forma de pagamento, não aqui embaixo. */}
            <div className="form-control w-full">
                <label className="label">
                    <span className="label-text font-medium">
                        Título (opcional)
                    </span>
                </label>
                <input
                    type="text"
                    className="input input-bordered w-full"
                    placeholder="Ex: Consulta de rotina"
                    value={title}
                    onChange={e => onTitleChange(e.target.value)}
                />
            </div>

            {clientTriages.length > 0 && (
                <div className="form-control w-full mt-4">
                    <label className="label">
                        <span className="label-text font-medium">
                            Vincular Triagem
                        </span>
                    </label>
                    <select
                        className="select select-bordered w-full"
                        value={triageId}
                        onChange={e => onTriageIdChange(e.target.value)}
                    >
                        <option value="">Nenhuma (opcional)</option>
                        {clientTriages.map(triage => (
                            <option key={triage.id} value={triage.id}>
                                #{triage.id} - {URGENCY_LABELS[triage.urgency]}{' '}
                                -{' '}
                                {triage.chiefComplaint?.substring(0, 30) ||
                                    'Sem queixa'}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {/*
                <div className="form-control w-full mt-4">
                <label className="label">
                    <span className="label-text font-medium">Diagnóstico</span>
                </label>
                <textarea
                    className="textarea textarea-bordered w-full"
                    placeholder="Diagnóstico ou hipóteses diagnósticas..."
                    value={diagnosis}
                    onChange={e => onDiagnosisChange(e.target.value)}
                    rows={3}
                />
            </div>

            <div className="form-control w-full mt-4">
                <label className="label">
                    <span className="label-text font-medium">Plano de Tratamento</span>
                </label>
                <textarea
                    className="textarea textarea-bordered w-full"
                    placeholder="Descreva o plano de tratamento..."
                    value={treatmentPlan}
                    onChange={e => onTreatmentPlanChange(e.target.value)}
                    rows={3}
                />
            </div>
                */}
        </>
    )
}
